(function () {
  'use strict';

  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getFocusableElements(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (el) {
      return !el.disabled && el.getAttribute('aria-hidden') !== 'true' && el.offsetParent !== null;
    });
  }

  function isReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ── Desktop navigation ─────────────────────────────────────────── */

  function openDesktopPanel(panel, toggle) {
    if (!panel) return;
    panel.removeAttribute('hidden');
    panel.removeAttribute('inert');
    panel.classList.remove('pointer-events-none');
    panel.classList.add('sf-menu--a11y-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeDesktopPanel(panel, toggle) {
    if (!panel) return;
    panel.setAttribute('hidden', '');
    panel.setAttribute('inert', '');
    panel.classList.add('pointer-events-none');
    panel.classList.remove('sf-menu--a11y-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function initDesktopNav(header) {
    var menuItems = header.querySelectorAll('.sf-nav .sf-menu-item-parent');
    var keyboardOpenItem = null;

    function getSubmenu(item) {
      return item.querySelector('.sf-menu__submenu, .sf-menu__desktop-sub-menu');
    }

    function getToggle(item) {
      return item.querySelector('.sf-menu__submenu-toggle');
    }

    function openItem(item, viaKeyboard) {
      var submenu = getSubmenu(item);
      var toggle = getToggle(item);
      if (!submenu) return;

      if (viaKeyboard) {
        keyboardOpenItem = item;
        item.setAttribute('data-a11y-keyboard-open', 'true');
      }

      header.classList.add('sf-mega-active');
      item.classList.add('sf-menu-item--active');
      openDesktopPanel(submenu, toggle);
    }

    function closeItem(item, force) {
      if (!item) return;
      if (!force && item.getAttribute('data-a11y-keyboard-open') !== 'true' && item.classList.contains('sf-menu-item--active')) {
        return;
      }

      var submenu = getSubmenu(item);
      var toggle = getToggle(item);
      item.classList.remove('sf-menu-item--active');
      item.removeAttribute('data-a11y-keyboard-open');
      closeDesktopPanel(submenu, toggle);

      if (keyboardOpenItem === item) keyboardOpenItem = null;

      var anyActive = header.querySelector('.sf-menu-item--active');
      if (!anyActive) header.classList.remove('sf-mega-active');
    }

    function closeAllDesktop(except) {
      menuItems.forEach(function (item) {
        if (item !== except) closeItem(item, true);
      });
    }

    menuItems.forEach(function (item) {
      var toggle = getToggle(item);
      var submenu = getSubmenu(item);
      var link = item.querySelector('a.sf__parent-item, a.sf__sub-menu-link1');

      if (toggle && submenu) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          if (expanded) {
            closeItem(item, true);
            toggle.focus({ preventScroll: true });
          } else {
            closeAllDesktop(item);
            openItem(item, true);
            var focusable = getFocusableElements(submenu);
            if (focusable.length) focusable[0].focus({ preventScroll: true });
          }
        });

        toggle.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle.click();
          }
        });
      }

      if (link && submenu) {
        link.addEventListener('focus', function () {
          closeAllDesktop(item);
          openItem(item, false);
        });
      }

      item.querySelectorAll('.sf__menu-item-level2').forEach(function (level2) {
        var flyoutToggle = level2.querySelector('.sf-menu__flyout-toggle');
        var flyout = level2.querySelector('.sf-menu--sub-childlink');
        if (!flyoutToggle || !flyout) return;

        function openFlyout() {
          level2.classList.add('sf-flyout--active');
          openDesktopPanel(flyout, flyoutToggle);
        }

        function closeFlyout() {
          level2.classList.remove('sf-flyout--active');
          closeDesktopPanel(flyout, flyoutToggle);
        }

        flyoutToggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (flyoutToggle.getAttribute('aria-expanded') === 'true') {
            closeFlyout();
            flyoutToggle.focus({ preventScroll: true });
          } else {
            item.querySelectorAll('.sf-flyout--active').forEach(function (sibling) {
              var sibToggle = sibling.querySelector('.sf-menu__flyout-toggle');
              var sibFlyout = sibling.querySelector('.sf-menu--sub-childlink');
              sibling.classList.remove('sf-flyout--active');
              closeDesktopPanel(sibFlyout, sibToggle);
            });
            openFlyout();
            var focusable = getFocusableElements(flyout);
            if (focusable.length) focusable[0].focus({ preventScroll: true });
          }
        });

        flyoutToggle.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            flyoutToggle.click();
          }
        });

        level2.addEventListener('mouseenter', function () {
          if (flyout.hasAttribute('hidden')) openFlyout();
        });

        level2.addEventListener('mouseleave', function () {
          if (document.activeElement && flyout.contains(document.activeElement)) return;
          closeFlyout();
        });
      });
    });

    header.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var activeItem = header.querySelector('[data-a11y-keyboard-open="true"]');
      if (activeItem) {
        e.preventDefault();
        var toggle = getToggle(activeItem);
        closeItem(activeItem, true);
        if (toggle) toggle.focus({ preventScroll: true });
        return;
      }
      header.querySelectorAll('.sf-flyout--active').forEach(function (level2) {
        var flyoutToggle = level2.querySelector('.sf-menu__flyout-toggle');
        var flyout = level2.querySelector('.sf-menu--sub-childlink');
        level2.classList.remove('sf-flyout--active');
        closeDesktopPanel(flyout, flyoutToggle);
        if (flyoutToggle) flyoutToggle.focus({ preventScroll: true });
      });
    });

    document.addEventListener('focusin', function (e) {
      if (!header.contains(e.target)) {
        menuItems.forEach(function (item) {
          closeItem(item, true);
        });
        header.classList.remove('sf-mega-active');
      }
    });

    var hoverObserver = new MutationObserver(function () {
      menuItems.forEach(function (item) {
        var submenu = getSubmenu(item);
        var toggle = getToggle(item);
        if (!submenu || !toggle) return;

        var isActive = item.classList.contains('sf-menu-item--active');
        var isKeyboard = item.getAttribute('data-a11y-keyboard-open') === 'true';

        if (isActive) {
          openDesktopPanel(submenu, toggle);
        } else if (!isKeyboard) {
          closeDesktopPanel(submenu, toggle);
        }
      });

      var megaActive = header.classList.contains('sf-mega-active');
      var anyItemActive = header.querySelector('.sf-menu-item--active');
      if (!anyItemActive && !keyboardOpenItem) {
        if (!megaActive) {
          menuItems.forEach(function (item) {
            closeDesktopPanel(getSubmenu(item), getToggle(item));
          });
        }
      }
    });

    menuItems.forEach(function (item) {
      hoverObserver.observe(item, { attributes: true, attributeFilter: ['class'] });
    });
    hoverObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── Mobile navigation ──────────────────────────────────────────── */

  function initMobileNav() {
    var hamburger = document.querySelector('.sf-menu-button');
    var drawer = document.getElementById('m-menu-drawer');
    if (!hamburger || !drawer) return;

    var drawerContent = drawer.querySelector('.m-menu-drawer__content');
    var closeBtn = drawer.querySelector('.m-menu-drawer__close');
    var lastFocus = null;
    var modalKeyHandler = null;
    var focusGuardHandler = null;

    function getMegamenu() {
      return window.__sfHeader && window.__sfHeader.megamenu;
    }

    function isDrawerOpen() {
      return drawer.classList.contains('open');
    }

    function setHamburgerExpanded(open) {
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      hamburger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }

    function syncSubmenuToggles() {
      drawer.querySelectorAll('.m-menu-mobile__toggle-button').forEach(function (btn) {
        var panelId = btn.getAttribute('aria-controls');
        if (!panelId) return;
        var panel = document.getElementById(panelId);
        btn.setAttribute('aria-expanded', panel && panel.classList.contains('open') ? 'true' : 'false');
      });
    }

    function getDrawerFocusable() {
      return getFocusableElements(drawerContent);
    }

    function moveDrawerFocus(backwards) {
      var focusable = getDrawerFocusable();
      var active = document.activeElement;
      var index = focusable.indexOf(active);

      if (index === -1) {
        focusable[0].focus({ preventScroll: true });
        return;
      }

      if (backwards) {
        index = index === 0 ? focusable.length - 1 : index - 1;
      } else {
        index = index === focusable.length - 1 ? 0 : index + 1;
      }

      focusable[index].focus({ preventScroll: true });
    }

    function trapDrawerKeys() {
      if (modalKeyHandler) return;

      modalKeyHandler = function (event) {
        if (!isDrawerOpen()) return;

        var key = event.key;
        var active = document.activeElement;

        if (key === 'Escape') {
          event.preventDefault();
          closeDrawer();
          return;
        }

        if (key === 'Tab') {
          var focusable = getDrawerFocusable();

          if (!drawer.contains(active) || focusable.indexOf(active) === -1) {
            event.preventDefault();
            if (focusable.length) focusable[0].focus({ preventScroll: true });
            return;
          }

          event.preventDefault();
          moveDrawerFocus(event.shiftKey);
        }
      };

      focusGuardHandler = function (event) {
        if (!isDrawerOpen()) return;
        if (!drawer.contains(event.target)) {
          event.preventDefault();
          var focusable = getDrawerFocusable();
          if (focusable.length) focusable[0].focus({ preventScroll: true });
        }
      };

      document.addEventListener('keydown', modalKeyHandler, true);
      document.addEventListener('focusin', focusGuardHandler, true);
    }

    function untrapDrawerKeys() {
      if (modalKeyHandler) {
        document.removeEventListener('keydown', modalKeyHandler, true);
        modalKeyHandler = null;
      }
      if (focusGuardHandler) {
        document.removeEventListener('focusin', focusGuardHandler, true);
        focusGuardHandler = null;
      }
    }

    function closeDrawer() {
      var megamenu = getMegamenu();
      if (megamenu && typeof megamenu.closeMenu === 'function') {
        megamenu.closeMenu();
      } else {
        drawer.classList.remove('open');
        document.documentElement.classList.remove('prevent-scroll');
        hamburger.classList.remove('active');
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    }

    hamburger.addEventListener('click', function () {
      if (!isDrawerOpen()) {
        lastFocus = document.activeElement;
      }
    });

    var drawerObserver = new MutationObserver(function () {
      var open = isDrawerOpen();
      setHamburgerExpanded(open);
      if (open) {
        if (!modalKeyHandler) trapDrawerKeys();
        var focusable = getDrawerFocusable();
        var target = closeBtn || focusable[0];
        if (target && !drawer.contains(document.activeElement)) {
          setTimeout(function () {
            target.focus({ preventScroll: true });
          }, isReducedMotion() ? 0 : 50);
        }
      } else {
        untrapDrawerKeys();
        syncSubmenuToggles();
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus({ preventScroll: true });
        } else {
          hamburger.focus({ preventScroll: true });
        }
        lastFocus = null;
      }
    });

    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    drawer.querySelectorAll('.m-megamenu-mobile').forEach(function (panel) {
      var panelObserver = new MutationObserver(syncSubmenuToggles);
      panelObserver.observe(panel, { attributes: true, attributeFilter: ['class'] });
    });

    drawer.addEventListener('click', function () {
      setTimeout(syncSubmenuToggles, 0);
    });

    setHamburgerExpanded(false);
    syncSubmenuToggles();
  }

  /* ── Init ───────────────────────────────────────────────────────── */

  function init() {
    var header = document.querySelector('.sf-header');
    if (header) initDesktopNav(header);
    initMobileNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
